/*eslint indent: [2, 4, {"SwitchCase": 0}]*/

export const BEGIN = 'BEGIN';
export const NEXT = 'NEXT';
export const REVERT = 'REVERT';
export const COMMIT = 'COMMIT';

const isInTransaction = action =>
    action.meta != null && action.meta.transaction != null;
const sameTransactionId = (action, id) =>
    isInTransaction(action) && action.meta.transaction.id === id;

let nextId = 1;
export function openTransaction() {
    const id = `transaction${nextId++}`;

    function converter(type, action) {
        return {
            ...action,
            meta: {
                ...action.meta,
                transaction: { id, type },
            },
        };
    }

    return converter;
}

export function transactionReducer(reducer) {
    const openUnits = new Set();
    let committedState;
    let pendingActions = [];

    return (state, action) => {
        if (isInTransaction(action)) {
            const { type, id } = action.meta.transaction;
            if (type !== BEGIN && openUnits.has(id) === false) {
                throw new Error(
                    `Attempted to ${type} when there is no transaction`
                );
            }

            /* eslint-disable indent */
            switch (type) {
                case BEGIN:
                    if (!committedState) {
                        committedState = state;
                    }
                    if (openUnits.has(id)) {
                        throw new Error('Use NEXT to continue working');
                    }
                    openUnits.add(id);
                    break;
                case NEXT:
                    break;
                case COMMIT:
                    openUnits.delete(id);

                    if (!openUnits.size) {
                        committedState = null;
                    }
                    break;
                case REVERT:
                    pendingActions = pendingActions.filter(
                        action => !sameTransactionId(action, id)
                    );
                    state = pendingActions.reduce(reducer, committedState);
                    break;
                default:
                    throw new Error(`Invalid type: ${type}`);
            }
            /* eslint-disable indent */
        }

        if (committedState != null) {
            pendingActions.push(action);
        }

        return reducer(state, action);
    };
}



// WEBPACK FOOTER //
// ./src/reducers/transactions.js